module.exports = __webpack_public_path__ + "img/image75.99a550ad.jpg";